import layoutAdmin from "@/layouts/layoutAdmin.vue";
import addProject from "@/views/module/project/projectManagement/addProject.vue";
import projectList from "@/views/module/project/projectManagement/projectList.vue";
import productDetailView from "@/views/module/project/projectManagement/projectDetailView.vue";
import projectTrainingSetup from "@/views/module/project/projectManagement/projectTrainingSetup.vue";
import contactSetup from "@/views/module/project/settingManagement/contactSetup.vue";
import authorSetup from "@/views/module/project/settingManagement/authorSetup.vue";
import projectSendMail from "@/views/module/project/mailManagement/projectSendMail.vue";
import projectThemeSetup from "@/views/module/project/settingManagement/projectThemeSetup.vue";
import projectTypeSetup from "@/views/module/project/settingManagement/projectTypeSetup.vue";
import projectReport from "@/views/module/project/projectManagement/projectReport.vue";
import progressTemplateSetup from '@/views/module/project/settingManagement/progressTemplateSetup.vue';
import progressTemplateList from '@/views/module/project/settingManagement/progressTemplateList.vue';
import projectBudget from "@/components/module/project/budgetManagement/projectBudget.vue";
export default [
    {
        path:'/project',
        component: layoutAdmin,
        meta:{
            UserLoggedIn: true,
            breadcrumb: "Projects Management"
        },
        children: [
            {
                path: "add-contact",
                name: "add-contact",
                meta: {
                    breadcrumb: ['Contacts Setup']
                },
                component: contactSetup,
            },
            {
                path: "add-author",
                name: "add-author",
                meta: {
                    breadcrumb: ['Authors Setup']
                },
                component: authorSetup, 
            },
            {
                path: "add-project-type",
                name: "add-project-type",
                meta: {
                    breadcrumb: ['Add Project Type']
                },
                component: projectTypeSetup,
            },
            {
                path: "add-project-theme",
                name: "add-project-theme",
                meta: {
                    breadcrumb: ['Add Project Theme']
                },
                component: projectThemeSetup,
            },
            {
                path: "send-mail",
                name: "send-mail",
                meta: {
                    breadcrumb: ['Send Mail']
                },
                component: projectSendMail,
            },
            {
                path: "add-project",
                name: "add-project",
                meta: {
                    breadcrumb: ['Add Project']
                },
                component: addProject,
            },
            {
                path: "project-detail/:id",
                name: "project-detail",
                meta: { 
                    breadcrumb: ["Project details"] 
                },
                component: productDetailView,
            },
            {
                path: "project-record",
                name: "project-record",
                meta : {
                    breadcrumb: ['Project Record']
                },
                component: projectList,
            },
            {
                path: "project-budget",
                name: "project-budget",
                meta: {
                    breadcrumb: ['Project Budget']
                },
                component: projectBudget,
            },
            


            {
                path: "project-training",
                name: "project-training",
                meta: {
                    breadcrumb: ['Project Training']
                },
                component: projectTrainingSetup,
            },
            {
                path: "project-report",
                name: "project-report",
                meta : {
                    breadcrumb: ['Project Report']
                },
                component: projectReport,
            },
            {
                path: "progress-template",
                name: "progress-template",
                meta: {
                breadcrumb: ['Purchase Management','Progress Template']
                },
                component: progressTemplateSetup,
            },
            {
                path: "progress-template-list",
                name: "progress-template-list",
                meta: {
                breadcrumb: ['Purchase Management','Progress Template List']
                },
                component: progressTemplateList,
            },
        ]
    }
]